import React from "react";
import { observer } from "mobx-react";
import { WorkerEventViewStore } from "../../store";
import { WorkerEventViewForm } from "./WorkerEventViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type WorkerEventViewProps = {
  workerEventViewStore: WorkerEventViewStore;
};

export const WorkerEventView: React.FC<WorkerEventViewProps> = observer(
  ({ workerEventViewStore }) => {
    return (
      <div>
        <WorkerEventViewForm
          queueName={workerEventViewStore.queueNameValue}
          jobType={workerEventViewStore.jobTypeValue}
          status={workerEventViewStore.statusValue}
          enqueuedAt={workerEventViewStore.enqueuedAtValue}
          startedAt={workerEventViewStore.startedAtValue}
          completedAt={workerEventViewStore.completedAtValue}
          payload={workerEventViewStore.payloadValue}
          result={workerEventViewStore.resultValue}
          error={workerEventViewStore.errorValue}
          retryCount={workerEventViewStore.retryCountValue}
          manualRetryCount={workerEventViewStore.manualRetryCountValue}
          nextRetryAt={workerEventViewStore.nextRetryAtValue}
          duration={workerEventViewStore.durationValue}
          correlationId={workerEventViewStore.correlationIdValue}
          triggerUserIdValue={workerEventViewStore.triggerUserIdValue}
          onPrint={(handlePrint: () => void) =>
            workerEventViewStore.printWorkerEvent(handlePrint)
          }
          onCancel={() => workerEventViewStore.cancelWorkerEvent()}
          onEdit={
            workerEventViewStore.isEditEnabled
              ? () => workerEventViewStore.editWorkerEvent()
              : undefined
          }
        />
        <ErrorDialog
          open={workerEventViewStore.errorDialogOpened}
          title={workerEventViewStore.errorTitle}
          description={workerEventViewStore.errorDescription}
          onClose={() => workerEventViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
